"use client";

import { createContext } from "react";
import { setSharedConfig } from "./libs";
import { SharedConfig } from "./types";

const SharedConfigServiceProviderContext = createContext<SharedConfig | null>(null);

export function SharedConfigServiceProvider({ config, children }: { children: React.ReactNode; config: SharedConfig }) {
  setSharedConfig({
    ...config,
  });

  return (
    <SharedConfigServiceProviderContext.Provider
      value={{
        ...config,
      }}
    >
      {children}
    </SharedConfigServiceProviderContext.Provider>
  );
}
